module.exports = __webpack_public_path__ + "img/VG.aa3f6c5a.png";